"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var meta_knowledge_provider_service_1 = require("../api/meta-knowledge-provider.service");
var party_provider_service_1 = require("../api/party-provider.service");
var core_1 = require("@angular/core");
var operators_1 = require("rxjs/operators");
var qr_code_module_1 = require("../../../controls/qr-code/qr-code.module");
var qr_code_component_1 = require("../../../controls/qr-code/qr-code.component");
var of_1 = require("rxjs/observable/of");
/**
 * Service for providing custom functions / component to custom portfolios.
 */
var DefaultPortfolioDefinitionCustomValuesService = /** @class */ (function () {
    function DefaultPortfolioDefinitionCustomValuesService(partyProviderService, metaKnowledgeProviderService) {
        this.partyProviderService = partyProviderService;
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
    }
    DefaultPortfolioDefinitionCustomValuesService.prototype.getCustomComponents = function (category, rootCategory) {
        var qrCodeComponent = {
            componentSelector: 'ejustice-qr-code',
            title: 'ejustice_qr_code',
            component: qr_code_component_1.QRCodeComponent,
            moduleLoaderFunction: function () { return qr_code_module_1.QRCodeModule; },
            participants: []
        };
        return of_1.of([qrCodeComponent]);
    };
    DefaultPortfolioDefinitionCustomValuesService.prototype.getCustomFields = function (category, rootCategory) {
        var loadPartyDefinitions$ = this.metaKnowledgeProviderService && this.partyProviderService ?
            this.metaKnowledgeProviderService.getPartyDefinitions(category) : Observable_1.Observable.of(null);
        return loadPartyDefinitions$.pipe(operators_1.map(function (partyDefinitions) {
            var fields = [];
            if (partyDefinitions) {
                if (partyDefinitions.parties) {
                    fields.push({ key: 'ejustice_parties', participants: [partyDefinitions.parties.field] });
                }
                if (partyDefinitions.participants) {
                    fields.push({ key: 'ejustice_participants', participants: [partyDefinitions.participants.field] });
                }
                if (partyDefinitions.advocates) {
                    fields.push({ key: 'ejustice_advocates', participants: [partyDefinitions.advocates.field] });
                }
            }
            return fields;
        }));
    };
    DefaultPortfolioDefinitionCustomValuesService.prototype.calculate = function (customFieldKey, category, entity, rootCategory) {
        if (entity) {
            switch (customFieldKey) {
                case 'ejustice_parties':
                    return this.constructParties(category, entity, 'getParties', 'parties', 'partyField');
                case 'ejustice_participants':
                    return this.constructParties(category, entity, 'getParticipants', 'participants', 'participantField');
                case 'ejustice_advocates':
                    return this.constructParties(category, entity, 'getAdvocates', 'advocates', 'advocateField');
            }
        }
        return of_1.of('');
    };
    DefaultPortfolioDefinitionCustomValuesService.prototype.constructParties = function (category, entity, partyFunction, definitionMainField, definitionPartyField) {
        return Observable_1.Observable.zip(this.metaKnowledgeProviderService.getPartyDefinitions(category), this.partyProviderService[partyFunction](category, entity.getInstanceId(), entity)).pipe(operators_1.map(function (_a) {
            var partyDefinitions = _a[0], subEntities = _a[1];
            var result = '';
            try {
                if (subEntities && subEntities.length) {
                    result = subEntities.map(function (sub) {
                        return sub.getProperty(partyDefinitions[definitionMainField][definitionPartyField]).value &&
                            sub.getProperty(partyDefinitions[definitionMainField][definitionPartyField]).value
                                .getProperty('name').value;
                    }).join('; ');
                }
            }
            catch (e) {
                console.error(e);
            }
            return result;
        }));
    };
    DefaultPortfolioDefinitionCustomValuesService = __decorate([
        __param(0, core_1.Optional()),
        __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [party_provider_service_1.PartyProviderService,
            meta_knowledge_provider_service_1.MetaKnowledgeProviderService])
    ], DefaultPortfolioDefinitionCustomValuesService);
    return DefaultPortfolioDefinitionCustomValuesService;
}());
exports.DefaultPortfolioDefinitionCustomValuesService = DefaultPortfolioDefinitionCustomValuesService;
//# sourceMappingURL=default-portfolio-definition-custom-values.service.js.map